__webpack_require__.p = "/text-sentiment-analysis/";